import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { AppCurrencyService } from './app-currency.service';

@Injectable({ providedIn: 'root' })
export class CurrencySelectionService {
  private readonly STORAGE_KEY = 'selectedCurrency';

  private selectedCurrencySubject: BehaviorSubject<string> =
    new BehaviorSubject<string>(
      localStorage.getItem(this.STORAGE_KEY) || 'EGP'
    );
  selectedCurrency$ = this.selectedCurrencySubject.asObservable();

  readonly currencySymbols: Record<string, string> = {
    EGP: 'EGP',
    USD: '$',
    SAR: '﷼',
  };

  constructor(private currencyService: AppCurrencyService) {}

  setSelectedCurrency(currency: string) {
    localStorage.setItem(this.STORAGE_KEY, currency);
    this.selectedCurrencySubject.next(currency);
  }

  getSelectedCurrency(): string {
    return this.selectedCurrencySubject.value;
  }

  getSelectedCurrencySymbol(): string {
    return (
      this.currencySymbols[this.getSelectedCurrency()] ||
      this.getSelectedCurrency()
    );
  }

  convertPrice(egpPrice: number): Observable<number> {
    const currency = this.getSelectedCurrency();
    if (currency === 'EGP') return of(egpPrice);

    return this.currencyService.convertFromEGP(currency, egpPrice);
  }
}
